module.exports = {"storeId":10001,"catalogId":10052,"langId":-7}


//////////////////
// WEBPACK FOOTER
// ./configuration/ConfigWcs.json
// module id = 492
// module chunks = 1